import { render, staticRenderFns } from "./CommunitySection.vue?vue&type=template&id=7328e31d&"
import script from "./CommunitySection.vue?vue&type=script&lang=js&"
export * from "./CommunitySection.vue?vue&type=script&lang=js&"
import style0 from "./CommunitySection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports